import React from 'react';
import { Outlet } from 'react-router-dom';

import PartnerSubNavigation from '../../components/partner-sub-navigation';

const View = () => (
  <>
    <PartnerSubNavigation />
    <Outlet />
  </>
);

export default View;
